// extracted by mini-css-extract-plugin
export default {"error-page":"error-page","content":"content","right":"right","subtitle":"subtitle","title":"title","divider":"divider","left":"left"};